import { Component, OnInit, OnDestroy } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../services/account.service';
import { SessionBookingVM } from '../../../models/SessionBookingVM';

@Component({
    selector: 'session-confirmed',
    templateUrl: './sessionconfirmed.component.html'
})
export class SessionBookingConfirmedComponent extends BaseComponent implements OnInit, OnDestroy {

    sessionDetails: SessionBookingVM | null;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private accService: AccountService
    ) {
        super(route);
    }

    ngOnInit(): void {
        this.sessionDetails = this.accService.confirmedSessionBooking;
        if (this.sessionDetails == null) {
            this.accounthome();
        }
    }

    ngOnDestroy(): void {
        this.accService.confirmedSessionBooking = null;
    }

    accounthome() {
        this.emitDisplayLoadingDialog(true);
        this.router.navigateByUrl('/');
        this.emitDisplayLoadingDialog(false);
    }

}
